import { render, staticRenderFns } from "./buffetTable.vue?vue&type=template&id=00045322&scoped=true&"
import script from "./buffetTable.vue?vue&type=script&lang=js&"
export * from "./buffetTable.vue?vue&type=script&lang=js&"
import style0 from "./buffetTable.vue?vue&type=style&index=0&id=00045322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00045322",
  null
  
)

export default component.exports